import { useMemo } from 'react'
import InfoListLayoutContext from './InfoListLayout.context'
import { Wrapper } from './InfoListLayout.styled'

export type InfoListLabelProps = {
  dataTest?: string
  labelWidth?: string
}

const InfoListLayout: React.FC<InfoListLabelProps> = ({
  children,
  labelWidth = '33%',
  dataTest = 'InfoList',
}) => {
  const infoListLayoutContextValue = useMemo(() => ({ labelWidth }), [labelWidth])

  return (
    <Wrapper data-test={dataTest}>
      <InfoListLayoutContext.Provider value={infoListLayoutContextValue}>
        {children}
      </InfoListLayoutContext.Provider>
    </Wrapper>
  )
}

export default InfoListLayout
